const REFRESH_INTERVAL = 20 * 60 * 1000;

// Refresh only the visible application, with one refresh in flight.
const foregroundRefresh = ({ refresh, isActive, target = window, documentTarget = document, now = Date.now, interval = REFRESH_INTERVAL, clock = { lastAttempt: now() } }) => {
    let stopped = false;
    let pending = false;
    let timer;
    const active = () => !stopped && isActive() && documentTarget.visibilityState === 'visible';
    const check = async () => {
        clearTimeout(timer);
        if (!active() || pending) return;
        const remaining = interval - (now() - clock.lastAttempt);
        if (remaining > 0) {
            timer = setTimeout(check, remaining);
            return;
        }
        pending = true;
        clock.lastAttempt = now();
        try {
            await refresh(active);
        } catch {
            // Core exposes request failures through its existing resource states.
        } finally {
            pending = false;
            if (active()) timer = setTimeout(check, interval);
        }
    };
    target.addEventListener('focus', check);
    documentTarget.addEventListener('visibilitychange', check);
    check();
    return () => {
        stopped = true;
        clearTimeout(timer);
        target.removeEventListener('focus', check);
        documentTarget.removeEventListener('visibilitychange', check);
    };
};

module.exports = { foregroundRefresh, REFRESH_INTERVAL };
